import { MyPurchasesScreenStyles } from './types';

export const getMyPurchasesScreenStyles = (): MyPurchasesScreenStyles => ({
    loaderWrapper: {
        height: '100%',
        justifyContent: 'center',
    },
});
